<template>
  <v-flex xs12 class="px-0">
    <v-flex xs12 class="py-0 mb-4 text-center">
      <v-flex xs12 mt-5 v-if="item.length > 0">
        <!-- dynamic -->
        <v-stepper alt-labels v-model="e1">
          <v-stepper-header>
            <template v-for="itemstep in item">
              <v-stepper-step
                :complete="itemstep.isComplete"
                color="bluedarken"
                :step="itemstep.step"
                :key="'step' + itemstep.step"
              >
                {{
                  part === 2
                    ? 'Approved by ' + itemstep.name
                    : itemstep.step > 3
                    ? 'Approved by ' + itemstep.name
                    : itemstep.name
                }}
              </v-stepper-step>
              <v-divider
                :key="itemstep.step"
                v-if="itemstep.step < item.length"
              ></v-divider>
            </template>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content
              v-for="n in steps"
              :key="`${n}-content`"
              :step="n"
              class="pa-0"
            ></v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
      <span v-else class="pl-7 fs-13 greylight--text">
        The approval list has not been created yet. Please ask the admin for
        more information.
      </span>
    </v-flex>
  </v-flex>
</template>

<script>
export default {
  props: {
    item: {
      type: Array
    },
    part: {
      type: Number,
      default: 1,
      require: false
    }
  },
  data() {
    return {
      e1: 0,
      steps: 5
    };
  },
  watch: {
    steps(val) {
      if (this.e1 > val) {
        this.e1 = val;
      }
    }
  },
  methods: {
    completeSubmit(val) {
      if (val == 0) return false;
      return true;
    },
    complete1(val) {
      if (val > 1) return true;
      return false;
    },
    complete2(val) {
      if (val > 2) return true;
      return false;
    },
    complete3(val) {
      if (val > 3) return true;
      return false;
    },
    complete4(val) {
      if (val > 4) return true;
      return false;
    },
    complete5(val) {
      if (val > 5) return true;
      return false;
    },
    complete6(val) {
      if (val > 6) return true;
      return false;
    },
    nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1;
      } else {
        this.e1 = n + 1;
      }
    }
  }
};
</script>
